<template>
  <div class="profile-page">
    <div class="page-title">
      <div class="gender-bar" :class="genderClassRef"></div>
      <img :src="personImageSrcRef" class="person-image" :class="{ present: personImageUrlRef }"/>
      <div class="page-title-text-area">
        <h1 class="with-subhead">
          {{ titleRef }}
        </h1>
        <p v-if="profileTypeRef" class="subhead">
          <LinkIcon v-if="profileTypeRef == ProfileType.ManagedLinked" size="1x"/>
          <LockIcon v-if="profileTypeRef == ProfileType.ResearchRestricted" size="1x"/>
          {{ profileTypeTextRef }}
          <UserLink v-if="ownerRef" :userId="ownerRef?.id" dimmed></UserLink>
        </p>
      </div>
      <router-link v-if="personRef" :to="personRef.viewPersonUrl" class="btn btn-outline-primary btn-sm explore-link">
        <!-- <ArrowLeftIcon/> -->
        View in family tree
      </router-link>
    </div>
    <ul ref="tabsElemRef" class="nav nav-pills profile-tabs">
      <li class="nav-item">
        <button type="button" id="personTab" ref="personTabRef" class="nav-link active" data-bs-toggle="tab" data-bs-target="#personPane" role="tab" aria-controls="personPane" aria-selected="true">
          Person
        </button>
      </li>
      <li class="nav-item">
        <button type="button" id="matchesTab" class="nav-link" data-bs-toggle="tab" data-bs-target="#matchesPane" role="tab" aria-controls="matchesPane" aria-selected="false">
          Matches
        </button>
      </li>
      <li class="nav-item">
        <button type="button" id="contentTab" class="nav-link" data-bs-toggle="tab" data-bs-target="#contentPane" role="tab" aria-controls="contentPane" aria-selected="false">
          Photos & Files
          <span v-if="tagsRef.length > 0" class="count">{{ tagsRef.length }}</span>
        </button>
      </li>
      <li class="nav-item">
        <button type="button" id="sharingTab" class="nav-link" data-bs-toggle="tab" data-bs-target="#sharingPane" role="tab" aria-controls="sharingPane" aria-selected="false">
          Sharing
        </button>
      </li>
      <li class="nav-item">
        <button type="button" id="manageTab" class="nav-link" data-bs-toggle="tab" data-bs-target="#managePane" role="tab" aria-controls="managePane" aria-selected="false">
          Manage
        </button>
      </li>
    </ul>
    <div class="tab-content content-area">
      <section id="personPane" class="tab-pane show active" role="tabpanel" aria-labelled-by="personTab" tab-index="0">
        <div class="person-view-options">
          <div class="btn-group">
            <input type="checkbox" id="showMatchDataChk" class="btn-check" v-model="showMatchDataRef"/>
            <label for="showMatchDataChk" class="btn btn-outline-secondary btn-sm">
              Show match data
            </label>
          </div>
        </div>
        <ProfileRelationships v-if="personIdRef" 
          :person-id="personIdRef"
          :owner-only="!showMatchDataRef"/>
        <h5>Details</h5>
        <AssertionList 
          :person-id="personIdRef" 
          include-related 
          include-restricted
          dim-other-owners
          show-counts
          :owner-only="!showMatchDataRef"/>
      </section>
      <section id="matchesPane" class="tab-pane" role="tabpanel" aria-labelledby="matchesTab" tab-index="0">
        <ProfileMatchesEditor :person-id="personIdRef"/>
      </section>
      <section id="contentPane" class="tab-pane" role="tabpanel" aria-labelledby="contentTab" tab-index="0">
        <ContentEditor :item-type="ItemType.Person" :item-id="personIdRef"/>
      </section>
      <section id="sharingPane" class="tab-pane relation-secton" role="tabpanel" aria-labelledby="sharingTab" tab-index="0">
        <ProfileSharingEditor v-if="personIdRef" :person-id="personIdRef"/>
      </section>
      <section id="managePane" class="tab-pane" role="tabpanel" aria-labelled-by="manageTab" tab-index="0">
        <ProfileManager :person-id="personIdRef"/>
      </section>
    </div>
    <Modal id="explainRestrictedModal" title="Restricted profiles" info>
      <p>
        Profiles of living or recently living people are automatically <b>restricted</b> when you upload your tree.
        They are only visible to the tree owner.
        However, at the same time, a linked copy is created that can be managed and shared separately from the tree.
        Linked profiles are updated automatically whenever the tree profile they are linked to changes.
      </p>
    </Modal>
  </div>
</template>

<style lang="scss" scoped>
.page-title {
  position: relative;
  margin: 1rem 0 1.5rem;
  max-width: 700px;
  grid-template-columns: max-content max-content;

  .gender-bar {
    grid-column: 1;
    width: 10px;
    background-color: #e9e9e9;

    &.male {
      background-color: #c3d5ea;
    }

    &.female {
      background-color: #fadce1;
    }
  }

  img.person-image {
    grid-column: 2;

    &.present {
      margin: 0;
      margin-right: 0.75rem;
      width: 80px;
      height: 80px;
      object-fit: cover;
    }

    &:not(.present) {
      margin-left: 6px;
      opacity: 40%;
    }
  }

  .page-title-text-area {
    grid-column: 3;
  }

  .subhead {
    margin: 0;
  }

  .explore-link {
    grid-column: 1 / span 3;
    margin-top: 1rem;
    justify-self: start;

    @media (min-width: 768px) {
      position: absolute;
      bottom: 0;
      right: 0;
    }
  }
}

.alert {
  margin: 0;
}

.restricted-alert svg {
  margin-top: -2px;
  height: 1rem;
}

.linked-alert img {
  display: inline;
  width: 20px;
  // opacity: 60%;
  // filter to change color to 0d6efd
  filter: contrast(100%);
  
}

.alert, .nav, .tab-pane {
  max-width: 700px;
}

#contentPane {
  width: 100%;
  max-width: inherit;
}

section h5 {
  font-size: 1rem;
  font-weight: normal;
}

.tab-content > section.active {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.form-label {
  display: block;
  margin-bottom: 0.5rem;
}

#personPane {
  .person-view-options {
    display: flex;
    justify-items: start;
    font-size: 0.875rem;
  }

  .research-group-card, .profile-card, .family-group-card {
    margin-top: 0.5rem;
  }
}

.input-value {
  margin: 0;
}

.actions {
  margin-top: 1.5rem;
}

.assertion-list {
  max-width: 800px;
}

.child-option {
  button.btn-primary {
    margin-top: 1.5rem;
  }

  .help-text {
    margin-left: 1.5rem;
  }
}
</style>

<script lang="ts" setup>
import { computed, ref, watch } from 'vue'
import { areProfileRelationshipsLoaded, loadProfileRelationshipsAsync } from './ProfilePageDataLoader'
import { useDataGroupStore } from '@/gp/DataGroupStore'
import { useUserStore } from '@/gp/UserStore'
import { usePersonStore } from '@/rd/PersonStore'
import { useViewPersonStore } from '@/rd/ViewPersonStore'
import { useContentStore } from '@/rd/ContentStore'
import { useContentTagStore } from '@/rd/ContentTagStore'
import { genderImages, dottedPersonImage } from '@/rd/ResearchDataModel'
import { CompositeId } from '@/rd/CompositeId'
import { ItemType } from '@/rd/ResearchDataModel'
import { usePageTitle } from '@/util/AppUtil'
import { ProfileType, ProfileUtils } from './ProfileUtils'
import { LinkIcon, LockIcon } from '@zhuowenli/vue-feather-icons'
import { useTokenManager } from '@/auth/TokenManager'
import { Tab } from 'bootstrap'
import { useTabsTelemetry } from '@/util/TabTelemetry'
import { LoadMode } from '@/util/AsyncData'
import UserLink from '@/manage/users/UserLink.vue'
import ProfileMatchesEditor from './ProfileMatchesEditor.vue'
import ProfileRelationships from './ProfileRelationships.vue'
import ProfileSharingEditor from './ProfileSharingEditor.vue'
import AssertionList from '@/explore/AssertionList.vue'
import Modal from '@/util/Modal.vue'
import ContentEditor from '@/manage/content/ContentEditor.vue'
import ProfileManager from './ProfileManager.vue'

const props = defineProps<{
  personId?: string,
}>()

//const pageDataRef = ref<ProfilePageData>()
const showMatchDataRef = ref(false)

const tabsElemRef = ref<HTMLElement>()
const personTabRef = ref<HTMLButtonElement>()

const dataGroupStore = useDataGroupStore()
const personStore = usePersonStore()
const viewPersonStore = useViewPersonStore()
const userStore = useUserStore()
const contentStore = useContentStore()
const contentTagStore = useContentTagStore()
const tokenManager = useTokenManager()

// Async data (primary)
const personIdRef = computed(() => props.personId ?? dataGroupStore.getAsyncGroup(tokenManager.current.userProfileId)?.data?.startItemId)
const groupIdRef = computed(() => CompositeId.getGroupId(personIdRef.value!))
const asyncPersonRef = computed(() => personStore.getAsyncPerson(personIdRef.value, LoadMode.EnsureLoaded))
const asyncViewPersonRef = computed(() => viewPersonStore.getAsyncPerson(personIdRef.value, LoadMode.EnsureLoaded))
const asyncDataGroupRef = computed(() => dataGroupStore.getAsyncGroup(groupIdRef.value, LoadMode.EnsureLoaded))

// Loaded data
const personRef = computed(() => asyncPersonRef.value?.data)
const viewPersonRef = computed(() => asyncViewPersonRef.value?.data)
const dataGroupRef = computed(() => asyncDataGroupRef.value?.data)

// Loading state
const relationshipsLoadedRef = computed(() => areProfileRelationshipsLoaded(personIdRef.value!))
const detailsLoadedRef = computed(() => viewPersonRef.value && viewPersonStore.areDetailsLoaded(viewPersonRef.value?.id))
const dataLoadedRef = computed(() => [
  asyncPersonRef.value,
  asyncViewPersonRef.value,
  asyncDataGroupRef.value,
].every(a => a?.isLoadComplete()) && 
  relationshipsLoadedRef.value && 
  detailsLoadedRef.value)

// Complex loading
watch(relationshipsLoadedRef, async (loaded) => {
  if (personIdRef.value && !loaded) {
    await loadProfileRelationshipsAsync(personIdRef.value)
  }
}, { immediate: true })
watch(detailsLoadedRef, async (loaded) => {
  if (viewPersonRef.value && !loaded) {
    await viewPersonStore.ensureDetailsLoadedAsync(viewPersonRef.value.id!)
  }
}, { immediate: true })

// Lazy-loaded data
const tagsRef = computed(() => contentTagStore.getTagsForItems(ItemType.Person, [personIdRef.value], LoadMode.EnsureLoaded))

// Computed values
const genderClassRef = computed(() => [personRef.value?.displayProperties.gender?.toLowerCase()])
const personImageUrlRef = computed(() => personImageContentRef.value?.galleryUrl)
const placeholderImageUrlRef = computed(() => personRef.value?.restricted ? dottedPersonImage :
  genderImages[personRef.value?.displayProperties?.gender ?? "default"])
const personImageSrcRef = computed(() => personImageUrlRef.value ?? placeholderImageUrlRef.value)
const personImageContentRef = computed(() => {
  const contentId = personRef.value?.displayProperties?.primaryPhotoSignedUrl?.contentId
  return contentStore.getLoadedContents([contentId]).at(0)
})
const titleRef = computed(() => personRef.value?.displayName ?? "Unknown name")
const ownerRef = computed(() => userStore.getLoadedUser(dataGroupRef.value?.ownerId)) // loaded with group
const profileTypeTextRef = computed(() => ProfileUtils.getProfileSubtitle(profileTypeRef.value))
const profileTypeRef = computed(() => ProfileUtils.getProfileType(personRef.value, dataGroupRef.value, ownerRef.value))

usePageTitle("Profile", () => personRef.value?.displayName)
useTabsTelemetry(tabsElemRef)

watch(personIdRef, () => {
  // reset interactive state
  showMatchDataRef.value = false
  if (personTabRef.value) {
    new Tab(personTabRef.value).show()
  }
}, { immediate: true })

</script>
